import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import Layout from './components/Layout.tsx';
import Accueil from './pages/Accueil.tsx';
import Actualites from './components/Actualites.tsx';
import ReinitialisationMDP from './components/ReinitialisationMDP.tsx';
import Contact from './components/Contact.tsx';
import MaPage from './pages/MaPage.tsx';
import VerifMembre from './components/VerifMembre.tsx';
import './firebase';

const auth = getAuth();
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Persistance configurée avec succès');
  })
  .catch((error) => {
    console.error('Erreur lors de la configuration de la persistance:', error);
  });

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Routes publiques avec Layout */}
        <Route path="/" element={<Layout><Accueil /></Layout>} />
        <Route path="/actualites" element={<Layout><Actualites /></Layout>} />
        <Route path="/reset-password" element={<Layout><ReinitialisationMDP /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
       
        {/* Route de vérification de membre - publique mais sans navigation */}
        <Route path="/verif-membre/:id" element={<VerifMembre />} />
        <Route path="/verif-membre" element={<VerifMembre />} />
       
        {/* Route privée sans Layout */}
        <Route path="/mapage/*" element={<MaPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;